import React from 'react';
import ReactDOM from 'react-dom';
import classNames from "classnames/bind";

import styles from "./Modal.module.css";

const cx = classNames.bind(styles);

type Props = {
	isOpen: boolean,
	children: React.ReactNode,
	handleClose: () => void,
};

export const Modal: React.FC<Props> = ({ isOpen, children, handleClose }) => {
	if (!isOpen) return null;

	const onOverlayClick = (e: any) => {
		handleClose();
		e.stopPropagation();
	};

	const onModalClick = (e: any) => {
		e.stopPropagation()
	}

	return ReactDOM.createPortal(
		<div className={cx("modal")} onClick={onOverlayClick}>
			<div
				className={cx("modal_content")}
				style={window.innerWidth <= 575 ? { width: "90%", maxHeight: "90%" } : {}}
				onClick={onModalClick}
			>
				{children}
			</div>
		</div>,
		window.innerWidth <= 575 ? document.body : document.getElementById("screen")!)
}